import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1172d538"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "full" }, null, -1))
const _hoisted_2 = { class: "form-divider no-margin" }
const _hoisted_3 = { class: "basket-footer" }
const _hoisted_4 = { class: "taxes" }
const _hoisted_5 = { class: "total" }
const _hoisted_6 = { class: "total__text" }
const _hoisted_7 = { class: "total__price" }

import VHeader from '../shared/VHeader.vue'
import { IonPage, IonContent, IonHeader } from '@ionic/vue'
import { Purchases } from 'package-types'
import ProductItem from '../store/ProductItem.vue'
import { dismissCurrentModal } from '@/helpers/modal'
import { getDate, formatPrice } from '@/helpers/format'
import { onMounted, ref } from 'vue'
import fileService from '@/services/file-service'
import { useBasketStore } from '@/state/basket'
import { ImageResponse } from '@/models/Images'


export default /*#__PURE__*/_defineComponent({
  __name: 'PurchaseModal',
  props: {
    purchase: null
  },
  setup(__props: any) {

const props = __props as { purchase: Purchases.AiPurchase }


const basketImages = ref<ImageResponse | null>(null)
const { generateImagesFromBasket } = useBasketStore()

onMounted(async () => {
  const { imagesLinks } = await fileService.getImages(
    generateImagesFromBasket(props.purchase.products)
  )
  basketImages.value = imagesLinks
})

const checkForImage = images =>
  images[0] &&
  basketImages.value &&
  basketImages.value[images[0]] &&
  basketImages.value[images[0]].thumbnail
    ? basketImages.value[images[0]].thumbnail
    : ''

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), {
    fullscreen: "",
    class: "app-padding-y"
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createVNode(_unref(IonHeader), null, {
        default: _withCtx(() => [
          _createVNode(VHeader, {
            "small-margin": "",
            class: "app-padding-x",
            title: _ctx.$t('orders.title'),
            onBack: _unref(dismissCurrentModal)
          }, null, 8, ["title", "onBack"]),
          _createElementVNode("div", _hoisted_2, [
            _createTextVNode(_toDisplayString(_unref(getDate)(__props.purchase.paymentStatus.date)) + " ", 1),
            _createElementVNode("div", {
              class: _normalizeClass(["status", __props.purchase.paymentStatus.status])
            }, _toDisplayString(__props.purchase.paymentStatus.status), 3)
          ])
        ]),
        _: 1
      }),
      (__props.purchase && __props.purchase.products)
        ? (_openBlock(), _createBlock(_unref(IonContent), {
            key: 0,
            class: "basket-content app-padding-x"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.purchase.products, (product) => {
                return (_openBlock(), _createBlock(ProductItem, {
                  key: product.productId,
                  image: checkForImage(product.images),
                  product: product
                }, null, 8, ["image", "product"]))
              }), 128))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('basket.tax')), 1),
          _createElementVNode("div", null, _toDisplayString(_unref(formatPrice)(__props.purchase?.taxes || 0)), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(__props.purchase.products.length) + " " + _toDisplayString(_ctx.$t('basket.product')), 1),
          _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(formatPrice)(__props.purchase.total || 0)), 1)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})